export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    year = "",
    userDepartment = "",
    details = [],
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.increaseDocNumber || ""}</td>
      <td class="border text-center">${item.increaseDocDate || ""}</td>
      <td class="border px-1">${item.assetName || ""}</td>
      <td class="border text-center">${item.unit || ""}</td>
      <td class="border text-center">${fmt(item.quantity)}</td>
      <td class="border text-right px-1">${fmt(item.unitPrice)}</td>
      <td class="border text-right px-1">${fmt(item.amount)}</td>
      <td class="border text-center">${item.decreaseDocNumber || ""}</td>
      <td class="border text-center">${item.decreaseDocDate || ""}</td>
      <td class="border px-1">${item.decreaseReason || ""}</td>
      <td class="border text-center">${fmt(item.decreaseQuantity)}</td>
      <td class="border text-right px-1">${fmt(item.decreaseAmount)}</td>
      <td class="border px-1">${item.note || ""}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 10px; color: black; line-height: 1.3;">
      <table width="100%">
        <tr>
          <td width="40%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="60%" align="center">
            <div class="font-bold">Mẫu số S22-DN</div>
            <div style="font-style: italic; font-size: 9px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 14px;">SỔ THEO DÕI TÀI SẢN CỐ ĐỊNH VÀ CÔNG CỤ, DỤNG CỤ TẠI NƠI SỬ DỤNG</h2>
        <div style="margin-top: 5px; font-weight: bold;">Năm: ${year}</div>
        <div style="margin-top: 5px;">Tên đơn vị (phòng, ban hoặc người sử dụng): <span class="dotted-line" style="width: 300px; display: inline-block;">${userDepartment}</span></div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" colspan="7">Ghi tăng tài sản cố định và công cụ, dụng cụ</th>
            <th class="border" colspan="5">Ghi giảm tài sản cố định và công cụ, dụng cụ</th>
            <th class="border" rowspan="2" width="60">Ghi chú</th>
          </tr>
          <tr>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Tên, nhãn hiệu, quy cách...</th>
            <th class="border" width="40" rowspan="2">ĐVT</th>
            <th class="border" width="40" rowspan="2">SL</th>
            <th class="border" width="60" rowspan="2">Đơn giá</th>
            <th class="border" width="70" rowspan="2">Số tiền</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Lý do</th>
            <th class="border" width="40" rowspan="2">SL</th>
            <th class="border" width="70" rowspan="2">Số tiền</th>
          </tr>
          <tr>
            <th class="border" width="40">Số</th>
            <th class="border" width="50">Ngày</th>
            <th class="border" width="40">Số</th>
            <th class="border" width="50">Ngày</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">E</th>
            <th class="border">G</th>
            <th class="border">H</th>
            <th class="border">4</th>
            <th class="border">5</th>
            <th class="border">I</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 25px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 9px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 50px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 4px; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; padding: 0 10px; }
      </style>
    </div>
  `;
};
